var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('nav',{class:{ 'Nav__desktop': !_vm.mobile.isMobile, 'Nav__mobile': _vm.mobile.isMobile }},[(!_vm.mobile.isMobile)?_c('navigation-desktop',{attrs:{"is-master":_vm.isMaster,"nav-items":_vm.navItems,"user-is-client":!!(_vm.$auth.user && _vm.$auth.user.client)}}):_c('navigation-mobile',{attrs:{"nav-items":_vm.navItems}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }